import {keepPreviousData, queryOptions, useQuery} from '@tanstack/react-query'
import * as sdk from '@cypro/server/sdk'

type Input = sdk.GetPatientsCumulatedDoseData['query']

export function getPatientsCumulatedDoseOptions(input: Input) {
  return queryOptions({
    queryKey: ['patients-cumulated-dose', input],
    queryFn: async () => {
      const {data} = await sdk.getPatientsCumulatedDose({query: input})
      return data
    },
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  })
}

export function useGetPatientsCumulatedDose(input: Input) {
  const {data, ...rest} = useQuery({
    ...getPatientsCumulatedDoseOptions(input),
  })

  return {...rest, data}
}
